// extracted by mini-css-extract-plugin
module.exports = {"customModal":"styles_customModal__NJccd","modalContent":"styles_modalContent__Hu0OJ"};